import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { lessonsQueryKeys } from '@/data/services/querykeys';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useSingleCache } from '@/data/hook/query/v2/useCacheManager';

const useLessonWorkspace = () => {
  const {
    courseLineId: courseLineParam,
    moduleId: moduleParam,
    slug,
    unitId: unitParam,
    lessonId: lessonParam,
  } = useParams();
  const isNew = lessonParam === 'new';

  const courseLineId = Number(courseLineParam);
  const moduleId = Number(moduleParam);
  const unitId = Number(unitParam);
  const lessonId = Number(lessonParam);

  const lessonsQueryKey = lessonsQueryKeys.get(lessonId);

  const { data: lesson, isInitialLoading } = useQuery({
    ...lessonsQueryKey,
    enabled: !!slug && !!unitId && !isNew,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const cache = useSingleCache(lessonsQueryKey.queryKey);

  const isLoading = isInitialLoading && !!slug && !!unitId && !!lessonId;

  return {
    lesson,
    cache,
    slug,
    courseLineId,
    moduleId,
    unitId,
    lessonId,
    isLoading,
  };
};

export default useLessonWorkspace;
